import _ from 'lodash';
import { useCreateAdditionalrequest } from '../../../../requests/additionals-request';
import { useSelector } from 'react-redux';
import { getCurrentFiscalYear } from '../../../VehicleRequisition/utils/VehicleRequisitionUtils';

export default function useCreateAdditionalDraft() {
  const [createAdditionalDraft] = useCreateAdditionalrequest();
  const {
    selectedCustomerAccount,
    garageAddress,
    selectedReasonForRequest,
    isAcknowledged,
    selectedStandardItem,
    selectedOptions,
  } = useSelector((state) => state.additionalsReducer);

  return [
    (data) => {
      const stateObj = _.cloneDeep({
        acknowledged: isAcknowledged,
        additionalRequestId: null,
        agencyCode: selectedCustomerAccount?.agencyCode,
        bureauCode: selectedCustomerAccount?.bureauCode,
        officeCode: selectedCustomerAccount?.officeCode,
        customerId: selectedCustomerAccount?.customerAccountId,
        fiscalYear: `${getCurrentFiscalYear()}`,
        garageAddress: {
          countryCode: garageAddress?.country,
          addressLine1: garageAddress?.address1,
          addressLine2: garageAddress?.address2,
          city: garageAddress?.city,
          stateCode: garageAddress?.state,
          zipcode: garageAddress?.zip,
        },
        requestStatusCode: 'DRAFT',
        requestType: selectedReasonForRequest,
        sin: `${selectedStandardItem?.standardItemNumber}`,
        specificInstructions: null,
        options:
          selectedOptions?.length > 0
            ? selectedOptions
                .map((option) =>
                  option?.option?.equipmentCode?.code
                    ? {
                        equipmentCode: option.option.equipmentCode.code,
                        comment: option.comment,
                      }
                    : null,
                )
                .filter((option) => option !== null)
            : [],
      });

      const payload = _.merge(stateObj, data);

      return createAdditionalDraft({
        fetchPolicy: 'network-only',
        variables: {
          input: payload,
        },
      });
    },
  ];
}
